import DepsService from 'services/dependencies.js';
import { NetSales, NetSalesTranslation, SalesCategory } from './my-net-sales-performance.types';

const CONTEXT = 'dashboard';
const NUMBER_OF_WEEKS = 52;

const fetchMyNetSalesPerformanceData = (
  retailerId: number,
  salesCategoryId: number,
  numberOfWeeks: number = NUMBER_OF_WEEKS
): Promise<NetSales[]> => {
  const { url } = DepsService.rest.widgets.instant.myNetSalesPerformance;
  const queryParams = {
    salesCategoryId,
    numberOfWeeks,
  };
  const urlParams = {
    retailerId,
  };
  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

const fetchSalesCategories = (): Promise<SalesCategory[]> => {
  const { url } = DepsService.rest.widgets.instant.salesCategories;
  const queryParams = {};
  const urlParams = {};
  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

const fetchMyNetSalesTranslations = (locale: string): Promise<NetSalesTranslation[]> => {
  const { url } = DepsService.rest.widgets.instant.myNetSalesTranslations;
  const queryParams = { locale };
  const urlParams = {};
  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export default {
  fetchMyNetSalesPerformanceData,
  fetchSalesCategories,
  fetchMyNetSalesTranslations,
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/my-net-sales-performance.api.ts